(function () {
  'use strict';

  let angular = window.angular;

  ToolKitTemplateUnlinkController.$inject = [
    'Var',
    'AppUtils',
    '$translate',
    '$element',
    '$timeout',
  ];

  angular.module('app').component('toolkitTemplateUnlinkModal', {
    template:'<div ng-style="{opacity: ctrl.loading ? 0 : 1}"><div class="modal-header"><span translate>buttons.unlink</span> <span>Tool Kit Template: <strong>{{ctrl.ToolKitTemplate.name}}</strong></span></div><div class="modal-body text-center"><div ng-if="ctrl.canUnlink" translate="entities.toolkittemplate.actions.unlink" data-translate-values="{item: ctrl.ToolKitTemplate.name }"></div><div ng-if="!ctrl.canUnlink"><div class="alert alert-warning"></div><div class="table-responsive margin-top-5"><div class="col-xs-12 marginT5"><table ng-attr-id="projects-table" class="table table-hover no-wrap" style="width: 100%"><thead><tr><th></th><th></th></tr></thead></table></div></div></div></div><div ng-if="ctrl.ublinkToolKitTemplateError" class="alert alert-warning text-center marginB0 marginT10">{{ctrl.ublinkToolKitTemplateError}}</div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-danger" ng-disabled="!ctrl.canUnlink" ng-click="ctrl.unlinToolkitTemplate()" translate>buttons.unlink</button></div></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small\'"></spinner>',
    controller: ToolKitTemplateUnlinkController,
    controllerAs: 'ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function ToolKitTemplateUnlinkController(Var, utils, $translate, $element, $timeout) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.ToolKitTemplate = vm.resolve.toolKitTemplate;
      vm.varId = vm.resolve.varId;
      vm.unlinToolkitTemplate = unlinToolkitTemplate;
      vm.canUnlink = false;
      vm.projects = [];
      vm.loading = true;
      Var.prototype$verifyToolKitTemplateUnlink({
        id: vm.varId,
        fk: vm.ToolKitTemplate.id,
      }).$promise.then((res) => {
        vm.canUnlink = res.canUnlink;
        vm.projects = res.projects;

        initTable(vm.projects);
      });
    };

    function unlinToolkitTemplate() {
      if (!vm.ToolKitTemplate) {
        return;
      }

      vm.loading = true;
      Var.prototype$__unlink__toolkitTemplates({ id: vm.varId, fk: vm.ToolKitTemplate.id }, {})
        .$promise.then(function () {
          vm.loading = false;
          vm.modalInstance.close();
        })
        .catch(function (err) {
          console.log(err);
          vm.loading = false;
          let error = utils.getHTTPError(err);
          vm.UnlinToolkitTemplateError = error.code || error.message;
        });
    }

    function initTable(data) {
      const columns = [
        {
          data: 'name',
          title: $translate.instant('entities._all.project'),
          render: function (data, type, row) {
            const url =
              '/member/var/' +
              vm.varId +
              '/customer/' +
              row.customerId +
              '/project/' +
              row.id +
              '/direct-access';

            return '<a href="' + url + '">' + row.name + '</a>';
          },
        },
        {
          data: 'customerName',
          title: 'Customer',
          render: function (data, type, row) {
            const url = '/member/var/' + vm.varId + '/customer/' + row.customerId + '/project';

            return '<a href="' + url + '">' + row.customerName + '</a>';
          },
        },
      ];

      const dtOptions = {
        processing: true,
        searching: true,
        lengthChange: false,
        pageLength: 3,
        info: false,
        data: data,
        autoWidth: false,
        width: '50%',
        columns: columns,
      };

      $timeout(function () {
        const table = $element.find('#projects-table').DataTable(dtOptions);
        table.columns.adjust();
        vm.loading = false;
      });
    }
  }
})();
